"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _button = _interopRequireDefault(require("../../../../core/button"));
var _publishModal = _interopRequireDefault(require("./publishModal"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const initialState = {
  publish: false
};
class publishButton extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", initialState);
    _defineProperty(this, "_onCloseCancelModal", () => {
      this.setState(initialState);
      // if (this.props.onCloseCancel) this.props.onCloseCancel();
    });
    _defineProperty(this, "_onOpenPublishModal", () => {
      this.setState({
        publish: true
      });
    });
    _defineProperty(this, "_hideStartList", () => {
      return Promise.all([this.props.onUpdateCompetition(this.props.competition.id, 'displayStartList', false), this.props.onUpdateCompetition(this.props.competition.id, 'displayStartListNotes', false)]);
    });
  }
  render() {
    const competition = this.props.competition;
    if (!competition.competitionDays.some(day => day.startListRuns.length) && !competition.startListNotes) return null;
    if (competition.displayStartList || competition.displayStartListNotes) return /*#__PURE__*/_react.default.createElement(_button.default, {
      type: "primary",
      onClick: this._hideStartList,
      style: {
        marginBottom: '8px'
      }
    }, competition.displayStartList && competition.displayStartListNotes ? 'Hide notes and times from paddlers' : competition.displayStartList ? 'Hide Times from paddles (notes hidden)' : 'Hide Notes from paddlers (times already hidden)');
    return /*#__PURE__*/_react.default.createElement("span", null, !this.state.publish ? null : /*#__PURE__*/_react.default.createElement(_publishModal.default, {
      competition: this.props.competition,
      onCloseCancel: this._onCloseCancelModal,
      onUpdateCompetition: this.props.onUpdateCompetition
    }), /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onOpenPublishModal,
      type: "primary",
      style: {
        marginBottom: '8px'
      }
    }, "Publish Start List"));
  }

  // *******************************************************************************
  // PartialQuery definition
  // *******************************************************************************
}
_defineProperty(publishButton, "partialQueries", {
  Competition: _mergeBqlQueries({
    id: true,
    startListNotes: true,
    displayStartList: true,
    displayStartListNotes: true,
    competitionDays: {
      id: true,
      startListRuns: {
        id: true
      }
    }
  }, _publishModal.default.partialQueries.Competition)
});
var _default = exports.default = publishButton;